import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { startCheckout } from "@/lib/checkout";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-5 grain">
      <div className="max-w-xl w-full border border-white/10 bg-[#0a0a0a] p-10 relative">
        <div className="absolute top-5 right-5 font-mono text-[9px] tracking-[0.3em] text-red-500">
          STATUS · CANCELADO
        </div>
        <Logo className="h-8 w-8" />
        <XCircle className="h-10 w-10 text-red-500 mt-10 mb-5" />
        <div className="font-display text-3xl text-neutral-50">Pagamento cancelado</div>
        <p className="mt-4 text-neutral-500 text-sm">
          Nenhum valor foi cobrado. Você pode retornar e concluir sua compra a qualquer momento.
        </p>
        <div className="mt-10 flex gap-4">
          <button
            onClick={startCheckout}
            className="h-12 px-6 bg-red-600 hover:bg-red-700 font-mono tracking-[0.25em] text-[11px] uppercase"
          >
            Tentar novamente
          </button>
          <Link
            to="/"
            className="h-12 px-6 border border-white/15 text-neutral-300 inline-flex items-center font-mono tracking-[0.25em] text-[11px] uppercase hover:border-red-600"
          >
            Voltar
          </Link>
        </div>
      </div>
    </div>
  );
}
